import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'asana-trigger',
  name: 'Asana Trigger',
  category: 'triggers',
  description: 'Trigger workflows when changes occur in Asana (polling via Events API)',
  icon: 'asana',
  iconType: 'integration-icon',
  color: 'pink',
  version: '1.0.0',

  group: ['trigger', 'schedule'],

  defaults: {
    name: 'Asana Trigger',
    color: '#f06a6a'
  },

  credentials: [
    {
      name: 'asana_oauth2',
      required: true,
      displayName: 'Asana OAuth2'
    }
  ],

  subtitle: '={{ $parameter.pollMode === "everyXMinutes" ? "Poll every " + ($parameter.minuteInterval || 5) + " min" : $parameter.pollMode === "everyHour" ? "Poll every hour" : $parameter.pollMode === "everyDay" ? "Poll daily" : "Custom schedule" }}',

  inputs: [],

  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Events'
    }
  ],

  tags: ['asana', 'trigger', 'polling', 'events', 'tasks', 'projects'],

  comingSoon: false,

  metadata: {
    documentation: 'https://developers.asana.com/docs/events'
  }
};

export default definition;
